import { useEffect, useState, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios";

// import { IconButton } from "@mui/material";
// import DescriptionIcon from '@mui/icons-material/Description';
// import Tooltip from '@mui/material/Tooltip';


//TABS - BOOTSTRAP
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import DashboardHeader from "../../components/DashboardHeader";
// import TransactionList from "../accounting/TransactionList";
import UserAlerts from "../../components/UserAlerts";
import MeterView from "./MeterView";
import MeterReadings from "./MeterReadings";
import Loading from "../../components/Loading";



const Meter = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState('');
    const errorRef = useRef(null);

    const meterId = params.id

    // const [removeBorder, setRemoveBorder] = useState(true);
    const removeBorder = true
    
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data

        },
    });

    const { data: meter, isLoading: meterLoading } = useQuery({
        queryKey: ['meter', meterId],
        queryFn: async () => {
          const response = await authAxios.get(`rentals/meters/${meterId}`);
          setPageCount(response.data.page_count);
          return response.data
        },
    });


    // const { data: meterReadings, isLoading: meterReadingsLoading } = useQuery({
    //     queryKey: ['meterReadings', meterId],
    //     queryFn: async () => {
    //       const response = await authAxios.get(`rentals/meter-readings/?meter=${meterId}`);
    //       return response.data
    //     },
    //     enabled: !!meter
    // });


        

    //Bootstrap Tabs
    const [key, setKey] = useState('readings');
    const handleTabChange = (k) => {
        setKey(k)
    };

    // PAGINATION
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])


    // if (meterReadingsLoading || meterLoading) return <Loading loading={true} />;


    return (
        <div className="dashboard-main">
            {meter &&

            <section className="dashboard-content dashboard-content-compact">
                 <div ref={errorRef}>
                    <UserAlerts error={error} />
                </div>

                <div className="dashboard-content-header-nav">
                    <DashboardHeader dashboardTitle={meter.reference+" "+meter.customer} dashboardPreTitle="Utility Meters" removeBorder={removeBorder} />
                </div>
              
                <Tabs
                    activeKey={key}
                    onSelect={(k) => handleTabChange(k)}
                    className="dashboard-tabs"
                    id="property-tabs"
                    mountOnEnter={true}
                    unmountOnExit={true}
                    transition={false}
                    >
                    
                    <Tab eventKey="profile" title="Profile">
                        <MeterView 
                            meter={meter}
                            // setError={setError}
                        />
                    </Tab>

                    <Tab eventKey="readings" title="Readings">
                        <MeterReadings 
                            // meterReadings={meterReadings} 
                            meter={meter} 
                        />
                    </Tab>
                    
                </Tabs> 


            </section>
            }

        </div>
    );
  };
  
  export default Meter;